import {
  NBS_API_ONE_CLICK_SIGNUP_REQUEST,
  NBS_API_ONE_CLICK_SIGNUP_SUCCESS,
  NBS_API_ONE_CLICK_SIGNUP_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';

function nbsApiOneClickSignupRequest () {
  return { type: NBS_API_ONE_CLICK_SIGNUP_REQUEST };
}

function nbsApiOneClickSignupSuccess (response) {
  return {
    type: NBS_API_ONE_CLICK_SIGNUP_SUCCESS,
    response
  };
}

function nbsApiOneClickSignupError (error) {
  return {
    type: NBS_API_ONE_CLICK_SIGNUP_FAILURE,
    error: error.cause || error
  };
}

export function nbsApiOneClickSignup (data) {
  const url = 'signup';
  return dispatch => {
    dispatch(nbsApiOneClickSignupRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiOneClickSignupSuccess(response)))
      .catch(error => dispatch(nbsApiOneClickSignupError(error)));
  };
}
